import React from 'react';
import LegalLandingPage from './LegalLandingPage';
import { COOKIES_POLICY } from './legalContent';

const CookiesPolicy: React.FC = () => (
  <LegalLandingPage
    doc={COOKIES_POLICY}
    footerLinks={[
      { to: '/terms-and-conditions', label: 'Terms and Conditions' },
      { to: '/privacy-policy', label: 'Privacy Policy' },
    ]}
  />
);

export default CookiesPolicy;
